export enum TooltipHeadPosition{
    Top = "top",
    Right ="right",
    Bottom = "bottom",
    Left = "left"
}